import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import { useQuery } from "@tanstack/vue-query";
import PlannerRepository from "@/repositories/PlannerRepository";
import logger from "@/services/logger";
import { HierarchyTag } from "@/types/HierarchyTag";

export const useHierarchyTags = () => {
  const currentCustomerName = useCurrentCustomerName();
  const currentSiteId = useCurrentSiteId();

  const { data, isLoading } = useQuery<HierarchyTag[]>({
    queryKey: ["hierarchy-tags", currentCustomerName, currentSiteId],
    queryFn: () => PlannerRepository.loadHierarchyTags(currentCustomerName, currentSiteId),
    useErrorBoundary: (error) => {
      logger.error(error);
      return false;
    },
  });

  return { hierarchyTags: data, isLoading };
};
